export default function Footer() {
    return (
        <footer>
            © 2023 <a href="https://aaron-tandem.vercel.app/" target="_blank" rel="noreferrer"> Aaron Tandem</a>. All rights reserved.
        </footer>
    )
}